import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

const t3Env = createEnv({
  client: {
    NEXT_PUBLIC_FIREBASE_API_KEY: z.string().min(1),
    NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: z.string().min(1),
    NEXT_PUBLIC_FIREBASE_DATABASE_URL: z.string().min(1),
    NEXT_PUBLIC_FIREBASE_PROJECT_ID: z.string().min(1),
    NEXT_PUBLIC_ENVIRONMENT: z.string().min(1),
    NEXT_PUBLIC_GAE_RUNTIME: z.string().optional(),
    NEXT_PUBLIC_SHARE_PATH: z.url(),
    NEXT_PUBLIC_SENTRY_DSN: z.url(),
    NEXT_PUBLIC_SENTRY_ENVIRONMENT: z.string().min(1),
    NEXT_PUBLIC_MANAGE_CLIENT_APP_HOST: z.url(),
    NEXT_PUBLIC_SERVER_API_HOST: z.url(),
    NEXT_PUBLIC_K1_AUTHORIZATION_ENDPOINT: z.url(),
    NEXT_PUBLIC_K1_CLIENT_ID: z.string().min(1),
    NEXT_PUBLIC_K1_CLIENT_ID_SA: z.string().optional(),
    NEXT_PUBLIC_K1_CLIENT_ID_KMDR: z.string().optional(),
    NEXT_PUBLIC_K1_CLIENT_ID_KSIEM: z.string().optional(),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN:
      process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    NEXT_PUBLIC_FIREBASE_DATABASE_URL:
      process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
    NEXT_PUBLIC_FIREBASE_PROJECT_ID:
      process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_GAE_RUNTIME: process.env.NEXT_PUBLIC_GAE_RUNTIME,
    NEXT_PUBLIC_SHARE_PATH: process.env.NEXT_PUBLIC_SHARE_PATH,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_SENTRY_ENVIRONMENT: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
    NEXT_PUBLIC_MANAGE_CLIENT_APP_HOST:
      process.env.NEXT_PUBLIC_MANAGE_CLIENT_APP_HOST,
    NEXT_PUBLIC_SERVER_API_HOST: process.env.NEXT_PUBLIC_SERVER_API_HOST,
    NEXT_PUBLIC_K1_AUTHORIZATION_ENDPOINT:
      process.env.NEXT_PUBLIC_K1_AUTHORIZATION_ENDPOINT,
    NEXT_PUBLIC_K1_CLIENT_ID: process.env.NEXT_PUBLIC_K1_CLIENT_ID,
    NEXT_PUBLIC_K1_CLIENT_ID_SA: process.env.NEXT_PUBLIC_K1_CLIENT_ID_SA,
    NEXT_PUBLIC_K1_CLIENT_ID_KMDR: process.env.NEXT_PUBLIC_K1_CLIENT_ID_KMDR,
    NEXT_PUBLIC_K1_CLIENT_ID_KSIEM: process.env.NEXT_PUBLIC_K1_CLIENT_ID_KSIEM,
  },
})

export const clientEnv = {
  firebase: {
    apiKey: t3Env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: t3Env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    databaseUrl: t3Env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
    projectId: t3Env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  },
  app: {
    environment: t3Env.NEXT_PUBLIC_ENVIRONMENT,
    gaeRuntime: t3Env.NEXT_PUBLIC_GAE_RUNTIME,
    sharePath: t3Env.NEXT_PUBLIC_SHARE_PATH,
  },
  sentry: {
    dsn: t3Env.NEXT_PUBLIC_SENTRY_DSN,
    environment: t3Env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  },
  manage: {
    clientAppHost: t3Env.NEXT_PUBLIC_MANAGE_CLIENT_APP_HOST,
  },
  api: {
    serverHost: t3Env.NEXT_PUBLIC_SERVER_API_HOST,
  },
  k1: {
    authorizationEndpoint: t3Env.NEXT_PUBLIC_K1_AUTHORIZATION_ENDPOINT,
    clientId: t3Env.NEXT_PUBLIC_K1_CLIENT_ID,
    clientIdSa: t3Env.NEXT_PUBLIC_K1_CLIENT_ID_SA,
    clientIdKmdr: t3Env.NEXT_PUBLIC_K1_CLIENT_ID_KMDR,
    clientIdKsiem: t3Env.NEXT_PUBLIC_K1_CLIENT_ID_KSIEM,
  },
} as const
